import {ISuperPacmanFetchInstallmentRequest, ISuperPacmanInstallment} from "@/types/ISuperPacman";
import {FetchSuperPacmanInstallment} from "./DataService";
import {IAuthError} from "@/types/auth";
import authHelper from "@/helpers/authHelper";

export class APISuperPacmanInstallment implements FetchSuperPacmanInstallment {
    async fetchData(params: ISuperPacmanFetchInstallmentRequest): Promise<ISuperPacmanInstallment> {
       const SHARED_PASSWORD = process.env.VUE_APP_MIDDLEWARE_SHARED_SECRET || "";
       try {
           params["sharedSecret"] = SHARED_PASSWORD;
           const response = await authHelper.fetchSuperPacmanInstallments(params);
           // Uncomment line below to test for vpop-180
           response["cumulativeBalance"]["enabled"] = response["cumulativeBalance"]["cumulativeBalanceEnabled"] ?? false;
           return response;
       }  catch (error) {
           if (error instanceof IAuthError) {
                console.error(`Authentication failed: ${error.message}`);
           } 
           throw error;
       }
    }
}
